import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  ConversationItemDataFragment,
  GetPatientConversationItemsDocument,
  GetPatientConversationItemsQueryVariables,
} from '../../types/api/graphql';

export function usePatientConversationItems(
  variables: GetPatientConversationItemsQueryVariables,
  skip?: boolean
) {
  const {
    data: patientConversationItemsData,
    loading: patientConversationItemsLoading,
  } = useCacheQuery(GetPatientConversationItemsDocument, {
    variables,
    skip: skip === true || !variables.healthProviderId || !variables.patientId,
  });

  const data = useMemo(
    () =>
      (patientConversationItemsData?.conversations ??
        []) as ConversationItemDataFragment[],
    [patientConversationItemsData?.conversations]
  );

  return {
    data,
    loading: patientConversationItemsLoading,
  };
}
